/**
 * journey.ts — the ONE way a journey begins (2026-09-09: "do not start
 * loading in the world till the end of the video or when the user decides
 * to skip the video").
 *
 * The traveler's BEGIN (and the menu's Enter when no traveler screen shows)
 * used to emit `atlas:menu-enter` directly — the event the world's entry,
 * the load screen's clock and the menu's dismissal hang off — so the world
 * streamed under the intro film. Now BEGIN emits `atlas:journey-begin` and
 * the journey gate (AtlasIntroVideoModule) forwards `atlas:menu-enter` only
 * when its narration card and film have ended or been skipped. A page
 * without the gate (a harness, an embed) enters at once — never a journey
 * that nobody answers.
 */
import { bus } from '../bus.js';

export type JourneyRoute = 'gated' | 'direct';

export function beginJourney(worldId: bigint | null): JourneyRoute {
  if (bus.listenerCount('atlas:journey-begin') > 0) {
    bus.emit('atlas:journey-begin', { worldId });
    return 'gated';
  }
  bus.emit('atlas:menu-enter', { worldId });
  return 'direct';
}
